import React from 'react';
import './css/header.css';
import UploadWrapper from "./UploadWrapper";
import PropTypes from "prop-types";

function Header({videos, isFetching}) {
    return (
        <div className="header">
            <div className={'column'}>
                <h1 className={'title'}>Faces</h1>
                <div className={'column store-buttons desktop'}>
                    <img src="./images/app-store.png" className='' alt="App Store"/>
                    {/*<img src="./images/google-play.png" className='' alt="Google Play"/>*/}
                </div>
            </div>

            <div className={`column ${videos.length ? '' : 'desktop'}`}>
                {isFetching ? <button className="btn third width100 disabled" >Upload my video
                </button> :  <UploadWrapper>
                    <button className="btn third width100">Upload my video
                    </button>
                </UploadWrapper>}
            </div>
        </div>
    );
}

Header.propTypes = {
    videos: PropTypes.array,
    isFetching: PropTypes.bool,
};

export default Header;
